import { configureStore } from '@reduxjs/toolkit'
import dataReducer_view1 from './data_view1'
import dataReducer_view2 from './data_view2'
import dataReducer_view3 from './data_view3'
import dataReducer_view4 from './data_view4'

export default configureStore({
  reducer: {
      data_view1: dataReducer_view1,
      data_view2: dataReducer_view2,
      data_view3: dataReducer_view3,
      data_view4: dataReducer_view4,
  }
})